import { removeCookie } from '../../../client/cookie/cookieService';
import { parseConfig } from '../../../shared/config';
import bffRequest from '../../../shared/requests/bffRequest';
import { generateLockeSignInUrl, isLockeIntegrationOn } from '../../../server/lockeService';

const isUnauthorised = err => (err && err.status === 401);

export function request(endpoint) {
  return bffRequest(endpoint)
    .then(null, (err) => {
      if (isUnauthorised(err)) {
        removeCookie('lmdstok', { domain: '.realcommercial.com.au', path: '/' });
      }
      return Promise.reject(err);
    });
}

export function requestWithLogout(endpoint) {
  const { LOCKE_CLIENT_ID, LOCKE_AUTH_REDIRECT_URL, WEBSITE_ROOT } = parseConfig();
  return request(endpoint)
    .then(null, (err) => {
      if (isUnauthorised(err)) {
        if (isLockeIntegrationOn()) {
          const lockeSignInLink = generateLockeSignInUrl(
            LOCKE_CLIENT_ID,
            LOCKE_AUTH_REDIRECT_URL,
            `${window.location.pathname}${window.location.search}`,
          );
          window.open(lockeSignInLink, '_self');
        } else {
          window.open(`${WEBSITE_ROOT}/sign-in?sessionExpired=true`, '_self');
        }
      }
      return Promise.reject(err);
    });
}
